<script lang="ts">
  import CheckboxTick from '../../../assets/svgs/checkbox-tick.svelte';

  export let label = '';
  export let name: string | undefined = undefined;
  export let error: boolean = false;
  export let success: boolean = false;
  export let theme: 'default' | 'pink' | 'black' = 'default';
  export let size: 'sm' | 'lg' = 'sm';

  export let checked = false;
  export let dataTestId: string | undefined = undefined;
  let customClass = '';
  export let plausibleClass: 'terms' | 'newsletters' | string = '';

  let tickClass = 'stroke-gray-950';
  let checkedBorderColor = success ? 'checked:border-gray-400' : 'checked:border-gray-950';
  let sizeClass = 'w-4 h-4 p-0.5';

  $: switch (theme) {
    case 'pink':
      tickClass = 'stroke-pink-600';
      checkedBorderColor = 'checked:bg-primary-50 checked:border-pink-600';
      break;
    case 'black':
      tickClass = 'text-white';
      checkedBorderColor =
        'checked:hover:bg-gray-900 checked:focus:bg-gray-900 checked:bg-gray-900 border-gray-900 border-2';
      break;
  }

  $: switch (size) {
    case 'sm':
      sizeClass = 'w-4 h-4';
      break;
    case 'lg':
      sizeClass = 'w-6 h-6 my-4 md:my-2 mr-2';
      break;
  }

  $: switch (plausibleClass) {
    case 'terms':
      customClass = 'plausible-event-name=new_paywall_check_terms';
      break;
    case 'newsletters':
      customClass = 'plausible-event-name=new_paywall_check_newsletters';
      break;
  }

  $: if (success) {
    checked = true;
  }

  $: labelTextColor = error
    ? 'text-error-500'
    : success
      ? 'text-gray-400'
      : checked
        ? 'text-gray-700'
        : 'text-gray-500';

  $: borderColor = error ? 'border-error-500' : 'border-gray-300';
</script>

<label class="flex flex-row gap-2 items-center relative">
  <input
    data-testid={dataTestId}
    type="checkbox"
    name={name || 'marketing'}
    bind:checked
    disabled={success}
    on:change|stopPropagation={() => {
      error = false;
    }}
    class="{customClass} {sizeClass} justify-center items-center border bg-white text-white rounded-sm focus:ring-1 {borderColor} {checkedBorderColor}"
  />
  {#if checked}
    <div class="absolute p-0.5 flex items-center">
      <CheckboxTick color={success ? 'stroke-gray-400' : tickClass} />
    </div>
  {/if}
  <span class="text-sm {labelTextColor}">
    {label}
    <slot />
  </span>
</label>

<style>
  [type='checkbox']:checked {
    content: '';
  }
</style>
